import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5001";

export default function StripeOnboardingComplete() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchStatus() {
      try {
        const res = await axios.get(`${API_BASE}/api/stripe/connect/status`, {
          withCredentials: true
        });
        setStatus(res.data);
      } catch (err) {
        console.error("Stripe connect status error:", err);
      }
      setLoading(false);
    }

    fetchStatus();
  }, []);

  if (loading) {
    return (
      <div className="p-6 text-center">
        <h2>Checking your Stripe account…</h2>
      </div>
    );
  }

  if (!status) {
    return (
      <div className="p-6 text-center">
        <h2>Could not load Stripe account status.</h2>
      </div>
    );
  }

  const { chargesEnabled, requirementsDue } = status;

  return (
    <div className="p-8 max-w-lg mx-auto text-center">
      <h1 className="text-3xl font-semibold mb-4">Stripe Account Linked 🎉</h1>

      {chargesEnabled && !requirementsDue && (
        <>
          <p className="mb-6">
            Your Stripe Express account is active and ready to receive rent payouts.
          </p>
          <button
            onClick={() => navigate("/stripe-payouts")}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg"
          >
            Go to Payout Dashboard
          </button>
        </>
      )}

      {!chargesEnabled && !requirementsDue && (
        <>
          <p>Your account is linked but Stripe is still verifying your details.</p>
          <p className="mt-3 opacity-70">This usually takes a few minutes.</p>
        </>
      )}

      {requirementsDue && (
        <>
          <p className="mb-6 text-red-600">Stripe requires additional information.</p>
          <button
            onClick={() => navigate("/stripe/onboarding/refresh")}
            className="px-6 py-3 bg-red-600 text-white rounded-lg"
          >
            Resume Stripe Onboarding
          </button>
        </>
      )}
    </div>
  );
}
